import {
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { FaChevronDown, FaSearch, FaTimes } from 'react-icons/fa'
import { LABEL, MESSAGE } from '../../../../constants'

const ExpenseGroupsDropDown = ({
  value,
  onChange,
  expenseGroups,
  loading,
  id = false
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [searchTerm, setSearchTerm] = useState('')

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value)
  }

  const filteredExpenseGroups = expenseGroups.filter((group) => {
    const query = searchTerm.toLowerCase()
    return (
      group.name.toLowerCase().includes(query) ||
      group.details.toLowerCase().includes(query)
    )
  })

  const selectedOption = expenseGroups.find((group) =>
    id ? group.id === value : group.name === value
  )
  const selectedLabel = selectedOption
    ? `${selectedOption.name} - ${selectedOption.details}`
    : LABEL.EXPENSE_GROUP_DROPDOWN.placeholder

  const handleSelectItem = (group) => {
    onChange(id ? group.id : group.name)
    setSearchTerm('')
    onClose()
  }

  const handleClearSelection = (e) => {
    e.stopPropagation()
    onChange('')
  }

  return (
    <Menu
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      closeOnSelect={false}
    >
      <Flex align="center" width="100%">
        <MenuButton
          as={Button}
          variant="outline"
          textColor="black"
          fontSize="sm"
          size="sm"
          width="100%"
          textAlign="left"
          fontWeight="light"
          rightIcon={<FaChevronDown />}
          border="1px"
          borderColor="black"
        >
          {selectedLabel}
        </MenuButton>
        {value && (
          <IconButton
            icon={<FaTimes />}
            size="sm"
            ml={2}
            aria-label={LABEL.CLEAR_SELECTION.label}
            onClick={handleClearSelection}
          />
        )}
      </Flex>
      <MenuList width="600px" p="0">
        <Box
          position="sticky"
          top="0"
          bg="white"
          zIndex="1"
          p="2"
          borderBottom="1px solid"
          borderColor="gray.200"
        >
          <Flex align="center">
            <FaSearch style={{ marginRight: '6px', color: '#718096' }} />
            <Input
              placeholder={LABEL.SEARCH.label}
              size="sm"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </Flex>
        </Box>
        <Box maxHeight="300px" overflowY="auto">
          {loading ? (
            <Box textAlign="center" p="2" width="600px" height="200px">
              <Spinner size="sm" />
            </Box>
          ) : (
            <>
              {filteredExpenseGroups.length === 0 ? (
                <Box textAlign="center" p="2">
                  <Text fontSize="sm" color="gray.500">
                    {MESSAGE.NO_ELEMENT_FOUND.label}
                  </Text>
                </Box>
              ) : (
                filteredExpenseGroups.map((group, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => handleSelectItem(group)}
                    fontSize="sm"
                  >
                    {group.name} - {group.details}
                  </MenuItem>
                ))
              )}
            </>
          )}
        </Box>
      </MenuList>
    </Menu>
  )
}

export default ExpenseGroupsDropDown
